module.exports = __webpack_public_path__ + "static/media/disappointed-face-svgrepo-com.9278d1b4.svg";